import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incorrect-page',
  templateUrl: './incorrect-page.component.html',
  styleUrls: ['./incorrect-page.component.css']
})
export class IncorrectPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
